var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-card-item',{attrs:{"icon":_vm.news.icon,"title":_vm.news.title,"subtitle":_vm.createdAt,"content":_vm.news.text},on:{"click":function($event){return _vm.$vfm.show({component: 'DashboardNewsViewModal', bind: { news: _vm.news }})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }